import { URLConfig } from '../components/global-nav/configs/base'
import { initUserData } from './user-info-config'

export enum AuthLiterals {
	UNAUTH = 'UNAUTH',
	AUTH = 'AUTH',
}

export enum AuthStorageKeys {
	externalIdToken = 'gbpe.auth.external.idToken',
	externalAccessToken = 'gbpe.auth.external.accessToken',
	state = 'gbpe.auth.state.param',
	clientID = '2816e68f-d202-4b18-9cc1-809160ffd363',
	forceLoginIndicator = 'gbpe.auth.login.force',
	serverOffset = 'gbpe.auth.server.offset',
	userActive = 'gbpe.auth.user.active',
	userLogout = 'gbpe.auth.user.logout',
	promptLogin = 'gbpe.auth.login.prompt',
}

export enum AuthEvents {
	loaded = 'gbpe-authLoaded',
	/** Dispatched on `window` when GBPE sets auth state (e.g. for host apps like Skyhawk Nav). */
	authStateUpdated = 'gbpe:authStateUpdated',
}

export enum AuthState {
	unAuthenticated = -1,
	loading = 0,
	authenticated = 1,
}

export enum verificationConstants {
	verified = 'yes',
}

export function clearSessionStorageOfGBPE(): void {
	sessionStorage.removeItem(AuthStorageKeys.externalIdToken)
	sessionStorage.removeItem(AuthStorageKeys.externalAccessToken)
	const keys = Object.keys(sessionStorage).filter(k => k.indexOf(AuthStorageKeys.clientID) !== -1)
	keys.forEach(k => sessionStorage.removeItem(k))
}

/**
 * Clears Session Storage Based on Requested Starting String
 */
function clearSessionStorageStartingWith(startingString) {
	for (const key in sessionStorage) {
		if (key.startsWith(startingString)) {
			sessionStorage.removeItem(key)
		}
	}
}

/**
 * Clearing sessionStorage of user information
 */
export function clearUserInfo(config: URLConfig): void {
	const userData = initUserData(config)
	sessionStorage.removeItem(userData.profile.storageKey)
	sessionStorage.removeItem(userData.rewards.storageKey)
	sessionStorage.removeItem(userData.vehicles.storageKey)
	sessionStorage.removeItem(userData.missingInfo.storageKey)
	clearSessionStorageStartingWith('GmOC')
}
